const CUSTOM_TABLE_MEMORY_KEY = 'tables';

export const setCustomTableMemory = (params: { tableName: string; value: string }): void => {
  const { tableName, value } = params;
  let tablesMemoryJson = localStorage.getItem(CUSTOM_TABLE_MEMORY_KEY);
  if (!tablesMemoryJson) {
    tablesMemoryJson = JSON.stringify({});
  }
  const tablesMemory = JSON.parse(tablesMemoryJson) as Record<string, string>;
  tablesMemory[tableName] = value;
  localStorage.setItem(CUSTOM_TABLE_MEMORY_KEY, JSON.stringify(tablesMemory));
};

export const getCustomTableMemoryItem = (tableName: string): string | null => {
  const tablesMemoryJson = localStorage.getItem(CUSTOM_TABLE_MEMORY_KEY);
  if (!tablesMemoryJson) {
    return null;
  }
  const tablesMemory = JSON.parse(tablesMemoryJson);
  const tableState = tablesMemory[tableName];
  if (!tableState) {
    return null;
  }
  return tableState;
};

export const clearCustomTableMemory = (): void => {
  localStorage.removeItem(CUSTOM_TABLE_MEMORY_KEY);
};
